export const setSessionStorage = (key: string, value: any) => {
    return sessionStorage.setItem(key, value)
}

export const getSessionStorage = (key: string) => {
    return sessionStorage.getItem(key)
}

export const removeSessionStorage = (key: string) => {
    return sessionStorage.removeItem(key)
}

export const clearSession = () => {
    sessionStorage.clear()
}

export const clearLocalStorage = () => {
    localStorage.clear()
}

export const setLocalStorage = (key: string, value: any) => {
    return localStorage.setItem(key, value)
}

export const getLocalStorage = (key: string) => {
    return localStorage.getItem(key)
}

export const removeLocalStorage = (key: string) => {
    return localStorage.removeItem(key)
}

export const clearSessionValues = () => {
    const entries = {
      "more-details-click": "false",
      "apiCall": "false",
      "folderApiCall": "false",
      "click": "true",
      "mapApiCall": "false",
      "previous": "false",
      "nextAndSelectedFlights": "false",
      "stepper": "0",
      "holidayRetrieveApiCall": "false",
      "transferApiCall": "false",
      "holidayPageLoad": "false"
    };
  
    Object.entries(entries).forEach(([key, value]) => {
      setSessionStorage(key, value);

    });
  };
  